import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  /* grid-template-columns: 1fr 450px; */
  grid-template-columns: 1fr 0.9fr;
  height: 100vh;
  
  button:hover {
    background: #F5890F;
  }

  .inicial {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;
  }
  .backgroung {
      position:absolute;
      z-index:0;
  }
  .wrapperButtons {
      display: flex;
      flex-direction: column;
      z-index:1;
      background: #ffffff;
      width: 90%;
      max-width: 650px;
      padding: 15px 15px;
      border-radius: 24px;
      text-align: center;
  }
  .subtitle {
      color: #f28c00;
      font-weight: 700;
      margin-bottom: 18px;
      letter-spacing: 0.5px;
  }
  .text {
      color: #444;
      font-size: 10px;
      line-height: 1.6;
      margin-bottom: 14px;
  }
  .button {
      display: flex;
      justify-content: center;
      align-items: center;
  }
  .button button {
      background: #8dc63f;
      color: #ffffff;
      border: none;
      padding: 12px 36px;
      font-size: 14px;
      font-weight: 600;
      border-radius: 8px;
      cursor: pointer;
      width: auto;
      height: auto;
  }
  .button button:hover {
        background: #7ab633;
  }
  .container-button {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .container-button-mob {
    display: none;
    justify-content: center;
    align-items: center;
  }
`;